module.exports = __webpack_public_path__ + "Lato-MediumItalic.b56b2012c6aa9ad5bd1d.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-MediumItalic.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-MediumItalic.eot
// module chunks = styles